<template>
  <modal :open="internalOpen" :width="1000">
    <template #header>
      <modal-header
        variant="cross"
        @cancel="closeModal()"
      >
        <h1>{{ $t(`pages.campaignList.modal.preview.title`) }}</h1>
      </modal-header>
    </template>

    <div class="mt-8 cont">
      <MultiImage :images="images" :enlargeable="true" />
    </div>
  </modal>
</template>

<script lang="ts" setup>
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import { useVModel } from '@vueuse/core';

import { useI18n } from 'vue-i18n';
import { useNotify } from '@utils/notifications';

import MultiImage from '@utils/MultiImage.vue';
import { computed } from 'vue';
import type {
  Campaign,
  CampaignGroup, DesignFile,
} from '@/entities/Entities';

interface Props {
  open: boolean;
  campaign?: Campaign;
  campaignGroup?: CampaignGroup;
}

const { t } = useI18n();

const notify = useNotify();

const emit = defineEmits(['update:open', 'saved']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);

function closeModal() {
  internalOpen.value = false;
}

const images = computed(() => props.campaign?.designPreviews?.map((designFile: DesignFile) => ({
  file: designFile.file,
  title: `Preview - ${props.campaign?.name}`,
})) ?? []);
</script>

<style lang="scss" scoped>
.cont{
  height: 50vh;
}
</style>
